/**
 * i18n-Konfiguration für Mehrsprachigkeit (Plan B)
 * Sprachen: de, de-neu, en, pl, hu
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import de from './locales/de.json';
import deNeu from './locales/de-neu.json';
import en from './locales/en.json';

/** Deep-merge: base + overrides (overrides gewinnt pro Key, rekursiv). */
function deepMerge(base, overrides) {
  const out = { ...base };
  for (const key of Object.keys(overrides || {})) {
    const b = base[key];
    const o = overrides[key];
    if (o != null && typeof o === 'object' && !Array.isArray(o) && b != null && typeof b === 'object' && !Array.isArray(b)) {
      out[key] = deepMerge(b, o);
    } else {
      out[key] = o;
    }
  }
  return out;
}

const resources = {
  de: { translation: de },
  'de-neu': { translation: deepMerge(de, deNeu) },
  en: { translation: en },
};

// Sprache aus localStorage (für späteren Sprachwechsel)
const savedLang = typeof window !== 'undefined' ? localStorage.getItem('stoppuhr_locale') : null;
const lng = savedLang && resources[savedLang] ? savedLang : 'de';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng,
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false, // React escaped bereits
    },
  });

export default i18n;
